"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Legend_1 = __importDefault(require("./Legend"));
var ToggleButtons_1 = __importDefault(require("../ToggleButtons"));
var GraphHeader = function (_a) {
    var _b;
    var views = _a.views, onViewChange = _a.onViewChange, legend = _a.legend, dataSets = _a.dataSets, _c = _a.toggleViewLabel, toggleViewLabel = _c === void 0 ? 'Toggle View' : _c, _d = _a.comparisonDataSets, comparisonDataSets = _d === void 0 ? [] : _d, className = _a.className;
    if (!views.length && !legend) {
        return null;
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('ui-graph-header', className) },
        react_1.default.createElement("div", { className: "ui-graph-views" }, views.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "ui-graph-views-title" }, toggleViewLabel),
            react_1.default.createElement(ToggleButtons_1.default, { options: views.map(function (view) { return ({ label: view.label, value: view.id }); }), value: (_b = views.find(function (v) { return v.active; })) === null || _b === void 0 ? void 0 : _b.id, onChange: function (option) { return onViewChange && onViewChange(option.value); } })))),
        legend && (react_1.default.createElement(Legend_1.default, { plots: __spreadArray(__spreadArray([], __read(dataSets.map(function (d) { return ({ label: d.label, color: d.color, dashed: false }); })), false), __read(comparisonDataSets.map(function (d) { return ({ label: d.label, color: d.color, dashed: true }); })), false) }))));
};
exports.default = GraphHeader;
